import React from 'react';
import { Link } from 'react-router-dom';
import ProductPage from '../components/ProductPage';
import useDocumentTitle from '../hooks/useDocumentTitle';
import { useTranslation } from 'react-i18next';

/**
 * Jeden katalog ładowarek. Domyślnie wallboxy AC ścienne; stacje wolnostojące
 * i DC dokłada przełącznik „Stacje komercyjne" w panelu filtrów.
 *
 * Wejście do kreatora jest NAD listą, bo to on odpowiada na pytanie, z którym
 * ludzie tu przychodzą („11 czy 22 kW?"). Sama lista z filtrami tego nie robi.
 */
const Wallboxes = () => {
  const { t } = useTranslation('lista');
  useDocumentTitle(t('tytul_strony.wallbox'));
    return (
        <div className='space-y-6'>
            <div className='max-w-7xl mx-auto px-4 md:px-8 mt-8'>
                <Link
                    to='/dobor-ladowarki'
                    className='block border border-blue-200 bg-blue-50 rounded-xl p-4 hover:bg-blue-100 transition-colors'
                >
                    <span className='font-bold text-gray-800'>{t('kreator_ladowarki.pytanie')}</span>
                    <span className='block text-sm text-gray-600 mt-0.5'>
                        {t('kreator_ladowarki.opis')}
                    </span>
                </Link>
            </div>
            <ProductPage productType="wallbox" />
        </div>
    )
}

export default Wallboxes;
